import { AppState } from '../reducers'
import { PRODUCT_STATE_KEY } from './constants'

export const getProductIds = (state: AppState) => state[PRODUCT_STATE_KEY]
